<template>
	<JBox>
		<CCodeEditor language="javascript" v-model="code" height="100vh" />
	</JBox>
</template>

<script>
import compileEditorAstToVueTemplate from "../compilers/compileEditorAstToVueTemplate"

export default {
	data() {
		return {
			code: ""
		}
	},

	methods: {
		init() {
			const component = this.$store.getters["uiEditor/selectedComponent"]

			const template = compileEditorAstToVueTemplate({
				editorAst: component?.editorAst ?? [],
				version: component?.version?.version,
				mode: "file"
			})

			const script = component?.editorScript

			// TODO: format code with prettier so that it looks awesome
			let output = "<template>\n" + template + "\n</template>"
			output += "\n<script" + ">\n" + script + "\n</" + "script>" // some shenanigans VScode gets confused when there is <script> involved
			this.code = output
		}
	},

	mounted() {
		this.init()
	},

	watch: {
		"$store.state.uiEditor.selectedComponentId": {
			handler() {
				this.init()
			},
			immediate: true,
			deep: false
		}
	}
}
</script>
